import { Button, Container, Paper, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 6, md: 10 } }}>
      <Paper variant="outlined" sx={{ p: 5, textAlign: "center" }}>
        <Typography
          variant="h2"
          sx={{ color: "primary.dark", fontWeight: 900, mb: 1 }}
        >
          404
        </Typography>
        <Typography variant="h5" gutterBottom>
          We couldn't find that page.
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          The link may be broken or the page may have moved.
        </Typography>
        <Stack direction="row" spacing={1.5} justifyContent="center">
          <Button component={RouterLink} to="/" variant="contained">
            Go home
          </Button>
          <Button component={RouterLink} to="/doctors" variant="outlined">
            Find a doctor
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
}
